import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import App from "./App";
import { syncDrafts } from "./lib/offline";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// ---------- PWA service worker registration ----------
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // periodic update check
        setInterval(() => reg.update(), 60 * 60 * 1000);
      })
      .catch((err) => {
        console.warn("SW registration failed:", err);
      });
  });
}

// ---------- Auto-sync drafts on first load (best-effort) ----------
if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    if (navigator.onLine) {
      // small delay to let the auth context settle before trying
      setTimeout(() => {
        syncDrafts().catch(() => {});
      }, 2500);
    }
  });
}
